//#region IMPORT
import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
/** Services Import */
import { useDispatch, useSelector } from 'react-redux';
import { showSnackbar } from '../../../../Reducer/SnackbarReducer';
/** Components */
import { PPE_BASIC } from './index';
import useCompanyCustDep from '../../../../hooks/useCompanyCustDep';

//#endregion

function PPE_BASICF() {
  //#region 변수
  const navigate = useNavigate();

  const { userInfo } = useSelector((state) => state.BaseInfo);

  const dispatch = useDispatch();
  const [value, setValue] = React.useState(0);
  const searchInfo = useSelector((state) => state.SearchInfo);

  const { handleCoChange, handleCustChange, handleDepChange } =
    useCompanyCustDep({
      requireCompany: true,
      requireCust: true,
      requireDep: false, // 부서는 탭별로 필요시 체크 (4번 탭에서만 필수)
      autoFetchDep: true, // 사업장 선택 시 부서 자동 조회
    });

  // 탭별 validateSelection 함수 (부서는 4번 탭에서만 필수)
  const validateSelection = () => {
    // 회사 선택 체크
    if (!searchInfo?.coCd) {
      dispatch(showSnackbar({ message: '회사를 선택하세요.', type: 'error' }));
      return false;
    }

    // 사업장 선택 체크
    if (!searchInfo?.custCd) {
      dispatch(
        showSnackbar({ message: '사업장을 선택하세요.', type: 'error' })
      );
      return false;
    }

    // 부서 선택 체크는 4번 탭(보호구 기록)에서만
    if (value === 3 && !searchInfo?.depCd) {
      dispatch(showSnackbar({ message: '부서를 선택하세요.', type: 'error' }));
      return false;
    }

    return true;
  };

  const [filterClick1, setFilterClick1] = useState(false); // 1번탭 버튼 이벤트
  const [searchClick1, setSearchClick1] = useState(false);
  const [addClick1, setAddClick1] = useState(false);
  const [saveClick1, setSaveClick1] = useState(false);
  const [deleteClick1, setDeleteClick1] = useState(false);
  const [printClick1, setPrintClick1] = useState(false);
  const [listClick1, setListClick1] = useState(false);

  const [filterClick2, setFilterClick2] = useState(false); // 2번탭 버튼 이벤트
  const [searchClick2, setSearchClick2] = useState(false);
  const [addClick2, setAddClick2] = useState(false);
  const [saveClick2, setSaveClick2] = useState(false);
  const [deleteClick2, setDeleteClick2] = useState(false);
  const [printClick2, setPrintClick2] = useState(false);
  const [listClick2, setListClick2] = useState(false);

  const [filterClick3, setFilterClick3] = useState(false); // 3번탭 버튼 이벤트
  const [searchClick3, setSearchClick3] = useState(false);
  const [addClick3, setAddClick3] = useState(false);
  const [saveClick3, setSaveClick3] = useState(false);
  const [deleteClick3, setDeleteClick3] = useState(false);
  const [printClick3, setPrintClick3] = useState(false);
  const [listClick3, setListClick3] = useState(false);

  const [filterClick4, setFilterClick4] = useState(false); // 4번탭 버튼 이벤트
  const [searchClick4, setSearchClick4] = useState(false);
  const [addClick4, setAddClick4] = useState(false);
  const [saveClick4, setSaveClick4] = useState(false);
  const [deleteClick4, setDeleteClick4] = useState(false);
  const [printClick4, setPrintClick4] = useState(false);
  const [listClick4, setListClick4] = useState(false);

  const executed = useRef(false);

  useEffect(() => {
    if (!executed.current && searchInfo.depCd) {
      Init();
      executed.current = true; // 다시 실행 안 되게
    }
  }, [searchInfo.depCd]);

  const Init = async () => {
    setSearchClick1(true);
  };
  // 탭 클릭 이벤트
  const HandleChange = (event, newValue) => {
    if (newValue === 0) setSearchClick1(true);
    else if (newValue === 1) setSearchClick2(true);
    else if (newValue === 2) setSearchClick3(true);
    else if (newValue === 3) setSearchClick4(true);
    setValue(newValue);
  };

  return (
    <div className="wrap">
      <PPE_BASIC
        navigate={navigate}
        userInfo={userInfo}
        value={value}
        setValue={setValue}
        filterClick1={filterClick1}
        setFilterClick1={setFilterClick1}
        searchClick1={searchClick1}
        setSearchClick1={setSearchClick1}
        addClick1={addClick1}
        setAddClick1={setAddClick1}
        saveClick1={saveClick1}
        setSaveClick1={setSaveClick1}
        deleteClick1={deleteClick1}
        setDeleteClick1={setDeleteClick1}
        printClick1={printClick1}
        setPrintClick1={setPrintClick1}
        listClick1={listClick1}
        setListClick1={setListClick1}
        filterClick2={filterClick2}
        setFilterClick2={setFilterClick2}
        searchClick2={searchClick2}
        setSearchClick2={setSearchClick2}
        addClick2={addClick2}
        setAddClick2={setAddClick2}
        saveClick2={saveClick2}
        setSaveClick2={setSaveClick2}
        deleteClick2={deleteClick2}
        setDeleteClick2={setDeleteClick2}
        printClick2={printClick2}
        setPrintClick2={setPrintClick2}
        listClick2={listClick2}
        setListClick2={setListClick2}
        filterClick3={filterClick3}
        setFilterClick3={setFilterClick3}
        searchClick3={searchClick3}
        setSearchClick3={setSearchClick3}
        addClick3={addClick3}
        setAddClick3={setAddClick3}
        saveClick3={saveClick3}
        setSaveClick3={setSaveClick3}
        deleteClick3={deleteClick3}
        setDeleteClick3={setDeleteClick3}
        printClick3={printClick3}
        setPrintClick3={setPrintClick3}
        listClick3={listClick3}
        setListClick3={setListClick3}
        filterClick4={filterClick4}
        setFilterClick4={setFilterClick4}
        searchClick4={searchClick4}
        setSearchClick4={setSearchClick4}
        addClick4={addClick4}
        setAddClick4={setAddClick4}
        saveClick4={saveClick4}
        setSaveClick4={setSaveClick4}
        deleteClick4={deleteClick4}
        setDeleteClick4={setDeleteClick4}
        printClick4={printClick4}
        setPrintClick4={setPrintClick4}
        listClick4={listClick4}
        setListClick4={setListClick4}
        dispatch={dispatch}
        showSnackbar={showSnackbar}
        // 함수
        handleCoChange={handleCoChange}
        handleCustChange={handleCustChange}
        handleDepChange={handleDepChange}
        validateSelection={validateSelection}
        HandleChange={HandleChange}
        // getDepLastName={getDepLastName}
      />
    </div>
  );
}

export default PPE_BASICF;
